import { render, staticRenderFns } from "./html-rich-editor-comp.vue?vue&type=template&id=a65320ca&"
import script from "./html-rich-editor-comp.vue?vue&type=script&lang=js&"
export * from "./html-rich-editor-comp.vue?vue&type=script&lang=js&"
import style0 from "./html-rich-editor-comp.vue?vue&type=style&index=0&id=a65320ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports